import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit } from '@angular/core';
import { MainService } from 'src/app/services/main-service.service';
import { environment } from 'src/environments/environment';
declare var Stripe: any;

@Component({
	selector: 'app-applepay',
	templateUrl: './applepay.component.html',
	styleUrls: ['./applepay.component.scss']
})
export class ApplepayComponent implements OnInit,AfterViewInit {

	applePayRequest: any;
	stripe: any;
	@Input('final_amount') final_amount: any = 10;
	@Input('customClass') customClass: any = '';
	@Output() confirmPayment = new EventEmitter<{ token: string, payment_source_type: number, wallet: number }>();

	constructor(public httpClient: HttpClient, public mainService: MainService) {

	}
	ngOnInit() {
		this.stripe = Stripe(this.mainService.stripe_pk);
		 console.log("this.final_amount apple pay--", this.final_amount, typeof (this.final_amount), parseFloat(this.final_amount || 1) * 100);
			this.applePayRequest = this.stripe.paymentRequest({
				country: 'US',
				currency: 'usd',
				total: {
					label: 'Total',
					amount: parseFloat(((this.final_amount || 1) * 100).toFixed(2)),
				},
				requestPayerName: true,
				requestPayerEmail: true,
			});
			// console.log("paymentRequest--", this.applePayRequest);
	}

	ngAfterViewInit(): void {
			var elements = this.stripe.elements();
			var prButton = elements.create('paymentRequestButton', {
				paymentRequest: this.applePayRequest,
				style: {
					paymentRequestButton: {
						type: 'default',
						// One of 'default', 'book', 'buy', or 'donate'
						// Defaults to 'default'

						theme: 'dark',
						// One of 'dark', 'light', or 'light-outline'
						// Defaults to 'dark'

						height: '45px'

						// Defaults to '40px'. The width is always '100%'.
					},
				},
			});
			// Check the availability of the Payment Request API first.
			this.applePayRequest.canMakePayment().then(function (result) {
				console.log('result>>>>>>>>>', result)
				// result.applePay = true;
				if (result && result.applePay) {
					console.log("result.applePay---", result.applePay);
					prButton.mount('#payment-request-button');
				} else {
					if (document.getElementById('payment-request-button')) {
						document.getElementById('payment-request-button').style.display = 'none';
					}
				}
			});
			this.applePayRequest.on('paymentmethod', ev => {
				// Confirm the PaymentIntent without handling potential next actions (yet).
				console.log("ev----", ev, ev.paymentMethod, ev.paymentMethod.id);
				if (ev && ev.paymentMethod && ev.paymentMethod.id) {
					this.confirmPayment.emit({ token: ev.paymentMethod.id, payment_source_type: 4, wallet: 1 });
				}
				this.mainService.walletActionSubject.subscribe(data => {
					ev.complete(data);
				});

			});
	}

	ngOnDestroy() {
		//this.mainService.walletActionSubject.unsubscribe();
	}
}
